import React, { Component } from 'react';
import Banner from './Banner';
// import NavBar from './NavBar';
import Counter from "./Counter"
import Features from "./Features4"
// import Footer from "./Footer"
class Home extends Component {
	constructor(props) {
		super(props);
		this.state = {
			homeRoute: true,
			isAppLinkClicked: false,
			prevY: 0
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}


	render() {
		let { homeRoute, isAppLinkClicked } = this.state;

		return (
			<div className="Home">

				<Banner />
				<Counter />
				<Features />

			</div>
		);
	}
}

export default Home;
